/* Big Wedge — Import Past Rounds page behaviour. Pure logic is in bw-importer-core.js. */
(function () {
  'use strict';
  var Core = window.BwImporterCore;
  var root = document.querySelector('[data-bw-importer]');
  if (!Core || !root) return;

  var apiUrl = (root.getAttribute('data-api-url') || '').replace(/\/+$/, '');
  var limits = {
    maxFiles: parseInt(root.getAttribute('data-max-files'), 10) || 8,
    maxFileBytes: (parseInt(root.getAttribute('data-max-file-mb'), 10) || 12) * 1048576,
    maxEdge: parseInt(root.getAttribute('data-max-edge'), 10) || 1600
  };
  var TOTAL_BUDGET = 3500000;   /* characters of image data per request; Vercel stops a body at 4.5MB */
  var REQUEST_TIMEOUT = window.BW_RI_REQUEST_TIMEOUT || 115000;   /* tests shorten this */

  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var refs = {
    status: q('[data-ri-status]'),
    clubhouse: q('[data-ri-clubhouse]'),
    clubhouseReview: q('[data-ri-clubhouse-review]'),
    detailsForm: q('[data-ri-form="details"]'),
    drop: q('[data-ri-drop]'),
    file: q('[data-ri-file]'),
    count: q('[data-ri-count]'),
    thumbs: q('[data-ri-thumbs]'),
    check: q('[data-ri-check]'),
    message: q('[data-ri-message]'),
    questionsForm: q('[data-ri-form="questions"]'),
    questions: q('[data-ri-questions]'),
    rows: q('[data-ri-rows]'),
    roundCount: q('[data-ri-round-count]'),
    confirmCheck: q('[data-ri-confirm-check]'),
    confirm: q('[data-ri-confirm]'),
    output: q('[data-ri-output]'),
    logNotice: q('[data-ri-log-notice]'),
    copy: q('[data-ri-copy]'),
    submit: q('[data-ri-submit]'),
    restart: q('[data-ri-restart]'),
    busy: q('[data-ri-busy]'),
    busyText: q('[data-ri-busy-text]'),
    fail: q('[data-ri-fail]'),
    failText: q('[data-ri-fail-text]'),
    retry: q('[data-ri-retry]')
  };

  var state = Core.emptyState();
  var busy = false;
  var lastRequest = null;     /* { run: function } so Try Again can repeat the failed action */
  var demoCalls = 0;
  var imageSeq = 0;

  /* ── Panels and messages ─────────────────────────────────────── */
  var TAB_FOR_PANEL = { 1: 1, 2: 2, 3: 3, 4: 3, 5: 4 };
  function show(n) {
    qa('[data-ri-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-ri-panel') !== String(n); });
    var tab = TAB_FOR_PANEL[n];
    qa('[data-ri-tab]').forEach(function (li) {
      var t = parseInt(li.getAttribute('data-ri-tab'), 10);
      if (t === tab) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      li.classList.toggle('is-done', t < tab);
    });
    refs.fail.hidden = true;
    var panel = q('[data-ri-panel="' + n + '"]');
    panel.focus({ preventScroll: true });
    var top = root.getBoundingClientRect().top + window.pageYOffset - 20;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function setStatus(text) { refs.status.textContent = text || ''; }
  function setError(name, text) { var el = q('[data-ri-error="' + name + '"]'); el.textContent = text; el.hidden = false; }
  function clearError(name) { var el = q('[data-ri-error="' + name + '"]'); el.textContent = ''; el.hidden = true; }
  function setBusy(on, text) {
    busy = on;
    root.classList.toggle('is-busy', on);
    root.setAttribute('aria-busy', on ? 'true' : 'false');
    refs.busy.hidden = !on;
    if (on) { refs.busyText.textContent = text || 'Checking your rounds…'; refs.fail.hidden = true; }
    qa('[data-ri-panel] button').forEach(function (b) { if (on) { b.setAttribute('data-was-disabled', b.disabled ? '1' : '0'); b.disabled = true; } else if (b.hasAttribute('data-was-disabled')) { b.disabled = b.getAttribute('data-was-disabled') === '1'; b.removeAttribute('data-was-disabled'); } });
  }
  function showFail(text, run) {
    lastRequest = run ? { run: run } : null;
    refs.failText.textContent = text;
    refs.retry.hidden = !run;
    refs.fail.hidden = false;
    refs.fail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /* ── Requests (real endpoint, or the built-in demo when none is set) ── */
  var ERROR_TEXT = {
    timeout: 'That took too long. Please try again.',
    network: 'We couldn’t reach the checking service. Check your connection and try again.',
    rate_limited: 'You’ve sent a lot of requests. Please wait a few minutes and try again.',
    too_large: 'Those images are too large to send together. Remove one or two and try again.',
    http_413: 'Those images are too large to send together. Remove one or two and try again.',
    model_unavailable: 'The checking service is busy right now. Please try again in a moment.',
    invalid_output: 'We couldn’t make sense of the result. Please try again.',
    origin: 'This page can’t talk to the checking service from here.',
    fallback: 'Something went wrong. Please try again.'
  };
  function apiError(code, message) { var e = new Error(message || ERROR_TEXT[code] || ERROR_TEXT.fallback); e.code = code; e.friendly = ERROR_TEXT[code] || ERROR_TEXT.fallback; return e; }

  function demoCall(body) {
    demoCalls += 1;
    var result = body.answers.length || body.duplicate_decisions.length ? Core.DEMO.second : Core.DEMO.first;
    return new Promise(function (resolve) { setTimeout(function () { resolve(JSON.parse(JSON.stringify(result))); }, 900); });
  }

  function callApi(path, body) {
    if (!apiUrl) return path === '/api/analyze' ? demoCall(body) : Promise.resolve({ logged: false, disabled: true });
    var ctl = new AbortController();
    var timer = setTimeout(function () { ctl.abort(); }, REQUEST_TIMEOUT);
    return fetch(apiUrl + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctl.signal })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (res.status === 200 && json && json.ok) return json.result;
          var code = (json && json.error && json.error.code) || ('http_' + res.status);
          throw apiError(code, json && json.error && json.error.message);
        });
      })
      .catch(function (err) {
        if (err && err.friendly) throw err;   /* a browser AbortError also has a numeric .code */
        if (err && err.name === 'AbortError') throw apiError('timeout');
        throw apiError('network');
      })
      .finally(function () { clearTimeout(timer); });
  }

  /* ── Step 1: details ─────────────────────────────────────────── */
  refs.detailsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var id = refs.clubhouse.value.trim();
    if (!id) { setError('clubhouse', 'Enter your ClubHouse ID to continue.'); refs.clubhouse.focus(); return; }
    clearError('clubhouse');
    state.clubhouseId = id;
    refs.clubhouseReview.value = id;
    show(2);
  });
  refs.clubhouse.addEventListener('input', function () { clearError('clubhouse'); });

  /* ── Step 2: upload ──────────────────────────────────────────── */
  function readImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('unreadable')); };
      img.src = url;
    });
  }
  function encode(img, edge, quality) {
    var scale = Math.min(1, edge / Math.max(img.naturalWidth, img.naturalHeight, 1));
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(img.naturalWidth * scale));
    c.height = Math.max(1, Math.round(img.naturalHeight * scale));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', quality);
  }
  function makeImage(file, edge, quality) {
    return readImage(file).then(function (img) {
      var dataUrl = encode(img, edge, quality);
      return { id: 'i' + (++imageSeq), name: file.name, mediaType: 'image/jpeg', dataUrl: dataUrl, base64: dataUrl.split(',')[1], file: file };
    });
  }
  function totalChars() { return state.images.reduce(function (n, im) { return n + im.base64.length; }, 0); }

  /* Re-encode everything smaller when the batch would not fit in one request. Returns true when it fits. */
  function fitBudget() {
    if (totalChars() <= TOTAL_BUDGET) return Promise.resolve(true);
    return Promise.all(state.images.map(function (im) { return makeImage(im.file, Math.min(limits.maxEdge, 1200), 0.65).then(function (small) { small.id = im.id; return small; }); }))
      .then(function (smaller) { state.images = smaller; renderThumbs(); return totalChars() <= TOTAL_BUDGET; });
  }

  function renderThumbs() {
    refs.thumbs.innerHTML = '';
    state.images.forEach(function (im, i) {
      var li = document.createElement('li');
      li.className = 'bw-ri__thumb';
      li.innerHTML = '<figure style="margin:0"><img src="' + im.dataUrl + '" alt=""><figcaption>' + (i + 1) + '. ' + esc(im.name) + '</figcaption></figure>' +
        '<button type="button" data-ri-remove-image="' + esc(im.id) + '" aria-label="Remove ' + esc(im.name) + '">×</button>';
      refs.thumbs.appendChild(li);
    });
    var n = state.images.length;
    refs.count.textContent = n === 0 ? 'No images selected' : n + (n === 1 ? ' image selected' : ' images selected');
  }

  function addFiles(fileList) {
    clearError('files');
    var check = Core.checkFiles(Array.prototype.slice.call(fileList), limits, state.images.length);
    var problems = check.rejected.map(function (r) { return r.name + ': ' + r.reason; });
    setBusy(true, 'Preparing your images…');
    return Promise.all(check.accepted.map(function (f) {
      return makeImage(f, limits.maxEdge, 0.82).catch(function () { problems.push(f.name + ': this image couldn’t be read in this browser. Try a JPG or PNG.'); return null; });
    })).then(function (made) {
      made.forEach(function (im) { if (im) state.images.push(im); });
      renderThumbs();
      if (problems.length) setError('files', problems.join(' '));
      setBusy(false);
      refs.file.value = '';
    });
  }

  refs.file.addEventListener('change', function () { if (!busy && refs.file.files.length) addFiles(refs.file.files); });
  refs.drop.addEventListener('click', function (e) { if (e.target.tagName !== 'LABEL') refs.file.click(); });
  refs.drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); refs.file.click(); } });
  ['dragenter', 'dragover'].forEach(function (ev) { refs.drop.addEventListener(ev, function (e) { e.preventDefault(); refs.drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { refs.drop.addEventListener(ev, function (e) { e.preventDefault(); refs.drop.classList.remove('is-over'); }); });
  refs.drop.addEventListener('drop', function (e) { if (!busy && e.dataTransfer && e.dataTransfer.files.length) addFiles(e.dataTransfer.files); });
  refs.thumbs.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ri-remove-image]');
    if (!btn || busy) return;
    state.images = state.images.filter(function (im) { return im.id !== btn.getAttribute('data-ri-remove-image'); });
    renderThumbs();
    clearError('files');
    refs.drop.focus();
  });

  function analyze(answers, decisions, busyText) {
    var run = function () {
      setBusy(true, busyText);
      return fitBudget().then(function (fits) {
        if (!fits) { setBusy(false); show(2); setError('files', ERROR_TEXT.too_large); return; }
        var body = Core.buildRequest(state, answers, decisions);
        return callApi('/api/analyze', body).then(function (result) { setBusy(false); handleResult(result); }, function (err) { setBusy(false); showFail(err.friendly, run); });
      });
    };
    return run();
  }

  refs.check.addEventListener('click', function () {
    if (busy) return;
    clearError('files');
    if (!state.images.length) { setError('files', 'Add at least one image of your rounds first.'); refs.drop.focus(); return; }
    state.rounds = []; state.questions = []; state.possibleDuplicates = [];
    analyze([], [], 'Checking your rounds… this can take a minute or two with several images.');
  });

  qa('[data-ri-back]').forEach(function (b) { b.addEventListener('click', function () { if (!busy) show(parseInt(b.getAttribute('data-ri-back'), 10)); }); });
  refs.retry.addEventListener('click', function () { if (!busy && lastRequest) lastRequest.run(); });

  /* ── Results routing ─────────────────────────────────────────── */
  function handleResult(result) {
    state = Core.applyResponse(state, result);
    if (state.status === 'ready_for_review' && state.rounds.length) { renderRows(); show(4); setStatus(state.message); return; }
    if (!state.questions.length && !state.possibleDuplicates.length) {
      show(2);
      setError('files', state.message || 'We couldn’t find any rounds in these images. Try clearer images or different screenshots.');
      return;
    }
    renderQuestions();
    show(3);
  }

  /* ── Step 3: questions and possible duplicates ───────────────── */
  function renderQuestions() {
    refs.message.textContent = state.message;
    refs.questions.innerHTML = '';
    clearError('questions');
    state.possibleDuplicates.forEach(function (d) {
      var f = document.createElement('fieldset');
      f.className = 'bw-ri__q';
      f.setAttribute('data-ri-dup', d.id);
      f.innerHTML = '<legend>' + esc(d.text) + '</legend>' +
        '<label><input type="radio" name="dup-' + esc(d.id) + '" value="keep_both"> Different rounds, keep both</label>' +
        '<label><input type="radio" name="dup-' + esc(d.id) + '" value="same"> The same round, keep one</label>';
      refs.questions.appendChild(f);
    });
    var thisYear = new Date().getFullYear();
    var groups = [], byRound = {};
    state.questions.forEach(function (qn) {
      var key = qn.round_id || '';
      if (!byRound[key]) { byRound[key] = { roundId: key, items: [] }; groups.push(byRound[key]); }
      byRound[key].items.push(qn);
    });
    groups.forEach(function (g) {
      var box = document.createElement('div');
      box.className = 'bw-ri__group';
      var round = null;
      state.rounds.forEach(function (r) { if (r.id === g.roundId) round = r; });
      var title = round ? (round.course_name || 'Round') : 'Other questions';
      var meta = [];
      if (round) {
        if (round.source_image) meta.push('Image ' + round.source_image);
        if (round.country) meta.push(round.country);
        if (round.round_date && Core.isRealDate(round.round_date)) meta.push(Core.formatDate(round.round_date));
        if (round.round_total != null) meta.push('Score ' + round.round_total);
        if (round.holes_played) meta.push(round.holes_played + ' holes');
      }
      box.innerHTML = '<div class="bw-ri__group-head"><div class="bw-ri__group-text"><span class="bw-ri__group-title">' + esc(title) + '</span>' + (meta.length ? '<span class="bw-ri__group-meta">' + esc(meta.join(' · ')) + '</span>' : '') + '</div>' +
        (round ? '<button type="button" class="bw-ri__discard" data-ri-discard="' + esc(round.id) + '">Remove this round</button>' : '') + '</div>';
      g.items.forEach(function (qn) { box.appendChild(renderQuestion(qn, thisYear, round)); });
      refs.questions.appendChild(box);
    });
  }
  function renderQuestion(qn, thisYear, round) {
      var d = document.createElement('div');
      d.className = 'bw-ri__field';
      var cid = 'bw-ri-q-' + qn.id;
      var control;
      if (qn.answer_type === 'course') {
        // Pick a listed course or type another: a text box with suggestions.
        var listId = cid + '-list';
        control = '<input type="text" id="' + esc(cid) + '" list="' + esc(listId) + '" data-ri-question="' + esc(qn.id) + '" autocomplete="off" placeholder="Choose or type the course">' +
          '<datalist id="' + esc(listId) + '">' + (qn.options || []).map(function (opt) { return '<option value="' + esc(opt) + '"></option>'; }).join('') + '</datalist>';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      } else if (qn.options && qn.options.length) {
        control = '<div class="bw-ri__choices" role="radiogroup" aria-labelledby="' + esc(cid) + '-label" data-ri-question="' + esc(qn.id) + '">' + qn.options.map(function (opt) {
          var shown = qn.answer_type === 'date' && Core.isRealDate(opt) ? Core.formatDate(opt) : opt;
          return '<label><input type="radio" name="q-' + esc(qn.id) + '" value="' + esc(opt) + '"> ' + esc(shown) + '</label>';
        }).join('') + '</div>';
        d.innerHTML = '<span class="bw-ri__qlabel" id="' + esc(cid) + '-label">' + esc(qn.text) + '</span>' + control;
      } else if (qn.answer_type === 'year') {
        var years = '';
        for (var y = thisYear; y >= thisYear - 9; y--) years += '<option value="' + y + '">' + y + '</option>';
        control = '<select id="' + esc(cid) + '" data-ri-question="' + esc(qn.id) + '"><option value="">Choose a year</option>' + years + '</select>';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      } else if (qn.answer_type === 'country') {
        control = '<select id="' + esc(cid) + '" data-ri-question="' + esc(qn.id) + '">' + countryOptions(null) + '</select>';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      } else if (qn.answer_type === 'date') {
        control = '<input type="date" id="' + esc(cid) + '" data-ri-question="' + esc(qn.id) + '" max="' + thisYear + '-12-31">';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      } else if (qn.answer_type === 'holes') {
        control = '<div class="bw-ri__choices" role="radiogroup" aria-labelledby="' + esc(cid) + '-label" data-ri-question="' + esc(qn.id) + '"><label><input type="radio" name="q-' + esc(qn.id) + '" value="9"> 9 holes</label><label><input type="radio" name="q-' + esc(qn.id) + '" value="18"> 18 holes</label></div>';
        d.innerHTML = '<span class="bw-ri__qlabel" id="' + esc(cid) + '-label">' + esc(qn.text) + '</span>' + control;
      } else if (qn.answer_type === 'score') {
        control = '<input type="number" inputmode="numeric" step="1" min="1" max="300" id="' + esc(cid) + '" data-ri-question="' + esc(qn.id) + '" placeholder="Final score">';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      } else {
        control = '<input type="text" id="' + esc(cid) + '" data-ri-question="' + esc(qn.id) + '" autocomplete="off">';
        d.innerHTML = '<label for="' + esc(cid) + '">' + esc(qn.text) + '</label>' + control;
      }
      if (round && round.round_total != null) {
        var head = document.createElement('div');
        head.className = 'bw-ri__qhead';
        head.appendChild(d.firstChild);
        head.insertAdjacentHTML('beforeend', '<span class="bw-ri__score" aria-label="Score">' + esc(round.round_total) + '</span>');
        d.insertBefore(head, d.firstChild);
      }
      return d;
  }

  refs.questions.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ri-discard]');
    if (!btn || busy) return;
    state = Core.removeRound(state, btn.getAttribute('data-ri-discard'));
    var box = btn.closest('.bw-ri__group');
    if (box) box.parentNode.removeChild(box);
    if (!state.rounds.length) setError('questions', 'Every round has been removed. Change your images to start again.');
  });

  refs.questionsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    var answers = [], decisions = [], missing = false;
    state.possibleDuplicates.forEach(function (d) {
      var picked = refs.questions.querySelector('input[name="' + CSS.escape('dup-' + d.id) + '"]:checked');
      if (!picked) { missing = true; return; }
      decisions.push({ duplicate_id: d.id, keep_both: picked.value === 'keep_both' });
    });
    state.questions.forEach(function (qn) {
      var el = refs.questions.querySelector('[data-ri-question="' + CSS.escape(qn.id) + '"]');
      var text = '';
      if (!el) { missing = true; return; }
      if (el.classList && el.classList.contains('bw-ri__choices')) {
        var picked = el.querySelector('input[type="radio"]:checked');
        text = picked ? picked.value : '';
      } else {
        text = (el.value || '').trim();
      }
      if (!text) { missing = true; return; }
      answers.push({ question_id: qn.id, question: qn.text, answer: text.slice(0, 600) });
    });
    if (missing) { setError('questions', 'Please answer every question before sending.'); return; }
    clearError('questions');
    analyze(answers, decisions, 'Updating your rounds…');
  });

  /* ── Step 4: review table ────────────────────────────────────── */
  function countryOptions(selected) {
    var html = '<option value="">Choose</option>';
    Core.COUNTRIES.forEach(function (c) { html += '<option value="' + esc(c) + '"' + (c === selected ? ' selected' : '') + '>' + esc(c) + '</option>'; });
    return html;
  }
  function rowError(text) { return text ? '<p class="bw-ri__error" role="alert">' + esc(text) + '</p>' : ''; }

  function renderRows() {
    refs.rows.innerHTML = '';
    state.rounds.forEach(function (r) {
      var v = Core.validateRound(r);
      var tr = document.createElement('tr');
      tr.setAttribute('data-ri-round', r.id);
      tr.className = v.ok ? '' : 'is-invalid';
      tr.innerHTML =
        '<td data-label="Course"><input type="text" data-ri-field="course_name" aria-label="Course" value="' + esc(r.course_name || '') + '">' + rowError(v.errors.course_name) + '</td>' +
        '<td data-label="Country"><select data-ri-field="country" aria-label="Country">' + countryOptions(r.country) + '</select>' + rowError(v.errors.country) + '</td>' +
        '<td data-label="Round Date"><input type="date" data-ri-field="round_date" aria-label="Round date" value="' + esc(r.round_date || '') + '">' + rowError(v.errors.round_date) + '</td>' +
        '<td data-label="Final Score"><input type="number" inputmode="numeric" step="1" min="1" max="300" data-ri-field="round_total" aria-label="Final score" value="' + (r.round_total == null ? '' : esc(r.round_total)) + '">' + rowError(v.errors.round_total) + '</td>' +
        '<td data-label="Holes Played"><select data-ri-field="holes_played" aria-label="Holes played"><option value="">Choose</option><option value="9"' + (r.holes_played === 9 ? ' selected' : '') + '>9</option><option value="18"' + (r.holes_played === 18 ? ' selected' : '') + '>18</option></select>' + rowError(v.errors.holes_played) + '</td>' +
        '<td data-label=""><button type="button" class="bw-ri__remove" data-ri-remove-round="' + esc(r.id) + '" aria-label="Remove the ' + esc(r.course_name || 'unnamed') + ' round">Remove</button></td>';
      refs.rows.appendChild(tr);
    });
    updateRoundCount();
    clearError('review');
  }

  function updateRoundCount() {
    var n = state.rounds.length;
    refs.roundCount.textContent = n === 0 ? 'No rounds left to import.' : n + (n === 1 ? ' round' : ' rounds') + ' ready to import';
    refs.roundCount.classList.toggle('bw-ri__count--empty', n === 0);
  }

  function readField(input) {
    var field = input.getAttribute('data-ri-field');
    var raw = input.value;
    if (field === 'round_total') { var n = parseInt(raw, 10); return raw.trim() === '' || !isFinite(n) ? null : n; }
    if (field === 'holes_played') return raw === '' ? null : parseInt(raw, 10);
    if (field === 'country') return raw || null;
    if (field === 'round_date') return raw || null;
    return raw;
  }

  /* Validate one row in place so the user does not lose focus while typing. */
  function refreshRow(tr) {
    var id = tr.getAttribute('data-ri-round');
    var r = state.rounds.filter(function (x) { return x.id === id; })[0];
    if (!r) return;
    var v = Core.validateRound(r);
    tr.classList.toggle('is-invalid', !v.ok);
    Array.prototype.forEach.call(tr.querySelectorAll('[data-ri-field]'), function (input) {
      var field = input.getAttribute('data-ri-field');
      var td = input.parentNode;
      var old = td.querySelector('.bw-ri__error');
      if (old) old.remove();
      if (v.errors[field]) td.insertAdjacentHTML('beforeend', rowError(v.errors[field]));
    });
  }

  function onRowEdit(e) {
    var input = e.target.closest('[data-ri-field]');
    if (!input) return;
    var tr = input.closest('[data-ri-round]');
    var fields = {};
    fields[input.getAttribute('data-ri-field')] = readField(input);
    state = Core.updateRound(state, tr.getAttribute('data-ri-round'), fields);
    refreshRow(tr);
  }
  refs.rows.addEventListener('input', onRowEdit);
  refs.rows.addEventListener('change', onRowEdit);
  refs.rows.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ri-remove-round]');
    if (!btn || busy) return;
    state = Core.removeRound(state, btn.getAttribute('data-ri-remove-round'));
    renderRows();
    setStatus('Round removed.');
    refs.confirmCheck.focus();
  });
  refs.clubhouseReview.addEventListener('input', function () { state.clubhouseId = refs.clubhouseReview.value.trim(); refs.clubhouse.value = refs.clubhouseReview.value; });
  refs.confirmCheck.addEventListener('change', function () { refs.confirm.disabled = !refs.confirmCheck.checked; });

  /* ── Step 5: confirm, copy, start again ──────────────────────── */
  var importId = '';
  function newId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); });
  }

  function confirmImport() {
    if (busy) return;
    clearError('review');
    if (!state.clubhouseId) { setError('review', 'Enter your ClubHouse ID above before confirming.'); refs.clubhouseReview.focus(); return; }
    if (!state.rounds.length) { setError('review', 'There are no rounds to import. Go back and add images, or answer the questions again.'); return; }
    var invalid = state.rounds.filter(function (r) { return !Core.validateRound(r).ok; });
    if (invalid.length) { setError('review', 'Fix the highlighted rounds first. Every round needs a course, date, final score and 9 or 18 holes.'); refs.rows.querySelector('tr.is-invalid input, tr.is-invalid select').focus(); return; }
    if (!refs.confirmCheck.checked) { setError('review', 'Tick the box to confirm the details are correct.'); refs.confirmCheck.focus(); return; }
    var data;
    try { data = Core.buildImportData(state.rounds); } catch (err) { setError('review', 'One of the rounds is incomplete. Check the highlighted row.'); return; }
    var problems = Core.validateImportData(data);
    if (problems.length) { setError('review', 'The import data didn’t pass our checks. Please review the rounds and try again.'); return; }
    refs.output.value = JSON.stringify(data, null, 2);
    importId = newId();
    refs.logNotice.hidden = true;
    submitted = false;
    refs.submit.disabled = false;
    refs.submit.textContent = 'Submit Import';
    show(5);
    setStatus('');
  }
  refs.confirm.addEventListener('click', confirmImport);

  /* Submit Import: sends the confirmed import to the Big Wedge team (the Google Sheet) on request. Never blocks the copy. */
  var submitted = false;
  function notice(kind, text) {
    refs.logNotice.className = 'bw-ri__notice' + (kind === 'warn' ? ' bw-ri__notice--warn' : '');
    refs.logNotice.textContent = text;
    refs.logNotice.hidden = false;
  }
  function recordImport(data) {
    var id = importId;
    refs.submit.disabled = true;
    refs.submit.textContent = 'Submitting…';
    refs.logNotice.hidden = true;
    var body = { import_id: id, clubhouse_id: state.clubhouseId, source_image_count: state.images.length, final_json: data };
    var call = apiUrl ? callApi('/api/log', body) : new Promise(function (resolve) { setTimeout(function () { resolve({ logged: true, duplicate: false }); }, 700); });
    call.then(function (result) {
      if (id !== importId) return;
      if (!result || result.disabled) {
        refs.submit.disabled = false; refs.submit.textContent = 'Submit Import';
        notice('warn', 'Submitting isn’t available right now. Copy the import data and paste it into the Big Wedge app instead.');
        return;
      }
      submitted = true;
      refs.submit.textContent = 'Submitted ✓';
      notice('ok', 'Thanks, your import has been sent. The Big Wedge team will add these rounds to your account within 3 days. Keep a copy of the import data in case you need it.');
    }, function () {
      if (id !== importId) return;
      refs.submit.disabled = false; refs.submit.textContent = 'Submit Import';
      notice('warn', 'We couldn’t send your import just now. Please try again, or copy the import data and paste it into the Big Wedge app.');
    });
  }
  refs.submit.addEventListener('click', function () {
    if (busy || submitted || refs.submit.disabled) return;
    var data;
    try { data = JSON.parse(refs.output.value); } catch (err) { notice('warn', 'The import data couldn’t be read. Go back and confirm your rounds again.'); return; }
    recordImport(data);
  });

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return legacyCopy(text); });
    }
    return Promise.resolve(legacyCopy(text));
  }
  function legacyCopy(text) {
    refs.output.focus();
    refs.output.select();
    refs.output.setSelectionRange(0, text.length);
    try { return document.execCommand('copy'); } catch (err) { return false; }
  }
  var copyTimer = null;
  refs.copy.addEventListener('click', function () {
    var text = refs.output.value;
    copyText(text).then(function (ok) {
      if (ok) {
        refs.copy.textContent = 'Copied ✓';
        refs.copy.classList.add('bw-btn--accent');
        setStatus('Import data copied. Paste it into the Big Wedge app.');
      } else {
        refs.output.focus(); refs.output.select();
        setStatus('Copy didn’t work on this device. The import data is selected, so copy it with your usual copy command.');
      }
      clearTimeout(copyTimer);
      copyTimer = setTimeout(function () { refs.copy.textContent = 'Copy Import Data'; refs.copy.classList.remove('bw-btn--accent'); }, 3000);
    });
  });

  var restartArmed = null;
  refs.restart.addEventListener('click', function () {
    if (restartArmed) {
      clearTimeout(restartArmed); restartArmed = null;
      state = Core.emptyState();
      importId = '';
      demoCalls = 0;
      refs.clubhouse.value = ''; refs.clubhouseReview.value = '';
      refs.output.value = ''; refs.thumbs.innerHTML = ''; refs.rows.innerHTML = ''; refs.questions.innerHTML = '';
      refs.count.textContent = 'No images selected';
      refs.confirmCheck.checked = false; refs.confirm.disabled = true;
      refs.logNotice.hidden = true;
      submitted = false; refs.submit.disabled = false; refs.submit.textContent = 'Submit Import';
      refs.restart.textContent = 'Start Another Import';
      ['clubhouse', 'files', 'questions', 'review'].forEach(clearError);
      setStatus('');
      show(1);
      refs.clubhouse.focus();
      return;
    }
    refs.restart.textContent = 'Click again to clear everything';
    setStatus('This clears the import you just made. Click the button again to start over.');
    restartArmed = setTimeout(function () { restartArmed = null; refs.restart.textContent = 'Start Another Import'; setStatus(''); }, 5000);
  });
})();
